module.exports = __webpack_public_path__ + "static/media/bg_15.cec1b4f4.png";